export const TERMS_AND_SERVICES_URL = 'https://www.mindright.io/terms-of-service';
export const PRIVACY_POLICY_URL = 'https://www.mindright.io/our-privacy-policy';
